/**
 * @generated SignedSource<<08ebd9c6ff53da40f5bb77fc02b29e73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BasicMetadata = {
  description?: string | null | undefined;
  title: string;
};
export type AclItem = {
  actions: ReadonlyArray<string>;
  role: string;
};
export type UploadCreateSeriesMutation$variables = {
  acl: ReadonlyArray<AclItem>;
  creator: string;
  metadata: BasicMetadata;
};
export type UploadCreateSeriesMutation$data = {
  readonly createSeries: {
    readonly id: string;
  };
};
export type UploadCreateSeriesMutation = {
  response: UploadCreateSeriesMutation$data;
  variables: UploadCreateSeriesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "acl"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "creator"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadata"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "acl",
        "variableName": "acl"
      },
      {
        "kind": "Variable",
        "name": "creator",
        "variableName": "creator"
      },
      {
        "kind": "Variable",
        "name": "metadata",
        "variableName": "metadata"
      }
    ],
    "concreteType": "Series",
    "kind": "LinkedField",
    "name": "createSeries",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UploadCreateSeriesMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "UploadCreateSeriesMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "f3d9ce26f3cffd58c8ab9533a144d3b0",
    "id": null,
    "metadata": {},
    "name": "UploadCreateSeriesMutation",
    "operationKind": "mutation",
    "text": "mutation UploadCreateSeriesMutation(\n  $metadata: BasicMetadata!\n  $acl: [AclItem!]!\n  $creator: String!\n) {\n  createSeries(metadata: $metadata, acl: $acl, creator: $creator) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e6f1e748889d34fea5688481186aa5f2";

export default node;
